import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import CartPageFooter from 'bento-ordering/cart/containers/CartPageFooter';
import BaseLayout from 'bento-ordering/base/layouts/Layout';
import { DEFAULT_LAYOUT_PADDING } from 'bento-ordering/base/style_mixins/layoutPadding';
import { isMobileMedia } from 'bento-ordering/utils/media';

export const CART_LAYOUT_ID = 'cart-layout';

const CartPageLayout = ({
  children,
  heroImageSrc,
  heroImageAlt,
  isFetching
}) => (
  <BaseLayout
    isFetching={isFetching}
    hideBrandFooterOnMobile
    hideHeroOnMobile
    hideNav={isMobileMedia()}
    isModal
    mobileFooter={<CartPageFooter />}
    layoutPadding={{ ...DEFAULT_LAYOUT_PADDING, pb: 9, pt: 2.5 }}
    heroSrc={heroImageSrc}
    heroAlt={heroImageAlt}
    id={CART_LAYOUT_ID}
    shouldUseMenuStyle={!isMobileMedia()}
  >
    {children}
  </BaseLayout>
);

CartPageLayout.propTypes = {
  children: PropTypes.object,
  heroImageSrc: PropTypes.string,
  heroImageAlt: PropTypes.string,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => {
  const image = get(state.menu, 'images[0]', {});
  return {
    isFetching: state.menu.isFetching,
    heroImageSrc: image.url,
    heroImageAlt: image.alt_text
  };
};

export default connect(mapStateToProps)(CartPageLayout);
